import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { CATEGORIES } from "../../lib/research";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const TplRow = ({ t, reload }) => {
  const [name, setName] = useState(t.name);
  const [qs, setQs] = useState(t.questions.join("\n"));
  const [cat, setCat] = useState(t.category);
  const save = () => api.put(`/research/templates/${t.id}`, { name, category: cat, questions: qs.split("\n").map((x) => x.trim()).filter(Boolean) })
    .then(() => { toast.success("टेम्पलेट सेव"); reload(); }).catch(() => toast.error("असफल"));
  const del = () => window.confirm("टेम्पलेट हटाएँ?") && api.delete(`/research/templates/${t.id}`).then(reload);
  return (
    <div className="rounded-lg border p-3 space-y-2" data-testid={`tpl-${t.id}`}>
      <div className="flex gap-2"><Input value={name} onChange={(e) => setName(e.target.value)} data-testid={`tpl-name-${t.id}`} />
        <select value={cat} onChange={(e) => setCat(e.target.value)} className="h-9 border rounded-md px-2 text-sm">{Object.entries(CATEGORIES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></div>
      <Textarea rows={5} value={qs} onChange={(e) => setQs(e.target.value)} className="text-sm" data-testid={`tpl-qs-${t.id}`} />
      <div className="flex gap-2"><Button size="sm" onClick={save} className="bg-teal-700 text-white" data-testid={`tpl-save-${t.id}`}>सेव</Button><Button size="sm" variant="ghost" className="text-red-600" onClick={del}>हटाएँ</Button></div>
    </div>
  );
};

export const TemplatesEditor = ({ onClose }) => {
  const [list, setList] = useState([]);
  const load = () => api.get("/research/templates").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = () => api.post("/research/templates", { name: "नया टेम्पलेट", category: "other", questions: ["पहला सवाल?"] }).then(load);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="templates-dialog">
        <DialogHeader><DialogTitle>चेकलिस्ट टेम्पलेट (हर लाइन = एक सवाल)</DialogTitle></DialogHeader>
        <div className="space-y-3">{list.map((t) => <TplRow key={t.id} t={t} reload={load} />)}</div>
        <Button variant="outline" onClick={add} data-testid="tpl-add">+ नया टेम्पलेट</Button>
      </DialogContent>
    </Dialog>
  );
};
